export const modalClasses = {
  titleOnTop: 'modal-title-on-top',
}
